import React, { useContext } from 'react';
import { Alert, Empty } from 'antd';

import AssigneeCard from '@totem/components/surveyV2/instanceDetail/AssigneeCard';
import AuditItem from '@totem/components/surveyV2/instanceDetail/AuditItem';
import ExportSurveyButton from '@totem/components/surveyV2/instanceDetail/ExportSurveyButton';
import FilteredSwitch from '@totem/components/surveyV2/instanceDetail/FilteredSwitch';
import HealthCard from '@totem/components/surveyV2/instanceDetail/HealthCard';
import OverviewCard from '@totem/components/surveyV2/instanceDetail/OverviewCard';
import SubmitButton from '@totem/components/surveyV2/instanceDetail/SubmitButton';
import SurveyInstance from '@totem/components/surveyV2/instanceDetail/SurveyInstance';
import SurveyContext from '@totem/components/surveyV2/instanceDetail/SurveyInstanceContext';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import colors from '@totem/styles/colors';
import { isNotNull, isNull } from '@totem/utilities/common';

import '../survey.css';

const styles = {
  divider: {
    background: colors.neutral.gray,
  },
  dateDivider: {
    height: '5rem',
    margin: '0 2rem',
  },
  alert: {
    margin: '1rem 0 2rem 0',
  },
  iframeContainer: {
    position: 'relative',
    paddingBottom: '56.25%',
    paddingTop: '2.5rem',
    height: 0,
    marginBottom: '3rem',
  },
  iframe: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
  },
};

const SurveyInstanceDetail = () => {
  const {
    data,
    loading,
    errorAlertVisible,
    setErrorAlertVisible,
    errors,
    isAuthenticated,
  } = useContext(SurveyContext);

  const getHelpTextClass = () => {
    return data.survey.helpText && !data.survey.isSubmitted ? 'help-text' : '';
  };

  if (isNull(data) || isNull(data.survey)) {
    return <Empty />;
  }

  return (
    <IBCard
      isCovered
      title={
        !isAuthenticated &&
        isNotNull(data) &&
        data.survey.type === 'policyAudit'
          ? 'Policy Audit'
          : !isAuthenticated && isNotNull(data) && data.survey.type === 'survey'
            ? 'Survey'
            : isNotNull(data.controlSystem) && data.controlSystem.name !== ''
              ? data.controlSystem.name
              : null
      }
    >
      <div styleName="survey-details">
        <div styleName="health-container">
          {!isAuthenticated && <AuditItem />}
          {isAuthenticated && <HealthCard />}
        </div>
        <div styleName="overview-container">
          <OverviewCard />
        </div>
        <div styleName="assignees-container">
          <AssigneeCard />
        </div>
      </div>
      {errorAlertVisible && !!errors.length && (
        <Alert
          message="It looks like you didn't answer all the required questions. Please review your answers."
          type="error"
          closable
          onClose={() => setErrorAlertVisible(false)}
          showIcon
          style={styles.alert}
        />
      )}
      <div>
        <div styleName={`header-container ${getHelpTextClass()}`} />
        <div styleName="submit-container">
          <div styleName="show-unanswered-container">
            <FilteredSwitch />
            <div styleName="show-unanswered">
              Show Unanswered Questions Only
            </div>
          </div>
          <div>
            {isNotNull(data) && isAuthenticated && (
              <span>
                <ExportSurveyButton surveyId={data.survey.id} />
                &nbsp;
              </span>
            )}
            <SubmitButton disabled={loading} />
          </div>
        </div>
        <SurveyInstance />
      </div>
    </IBCard>
  );
};

export default SurveyInstanceDetail;
